module.exports = __webpack_public_path__ + "static/media/fig_30.d8047b83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_30.jpg
// module id = 671
// module chunks = 0